import React, { useEffect } from "react";
// import KnowMore from "../KnowMore";
// import Resume from "../Resume";
import Myskill from "../Myskill";
import ProjectV2 from "../ProjectV2";
import Togrther from "../Togrther";
import Touch from "../Touch";

function Home() {
  useEffect(() => {
    document.title = "Pijush Ray Mondal : : Front-End Developer & Designer";
  });
  return (
    <>
      {/* knowMore replace to about */}
      {/* <KnowMore /> */}
      {/* <Resume /> */}
      <Myskill />
      <ProjectV2 />
      <Togrther />
      <Touch />
    </>
  );
}

export default Home;
